import { styled } from '@mui/material';
import { DatagridFooter } from 'shared/react-admin/DatagridFooter/DatagridFooter';

export const DatargidFooterStyled = styled(DatagridFooter)(({ theme }) => ({
  '& .MuiTableCell-root': { textAlign: 'right' },
  backgroundColor: theme.palette.tableHead,
}));
